interface CacheEntry {
  promise: Promise<any>;
  timestamp: number;
}

const CACHE_TTL_MS = 60 * 60 * 1000; // 60 minutes

export abstract class BaseApi {
  private static cached: { [tag: string]: { [key: string]: CacheEntry } } = {};

  private isExpired(entry: CacheEntry): boolean {
    return Date.now() - entry.timestamp > CACHE_TTL_MS;
  }

  protected GetCached(tag: string, cacheKey: string, request: () => Promise<any>): Promise<any> {
    if (!BaseApi.cached[tag]) {
      BaseApi.cached[tag] = {};
    }
    const entry = BaseApi.cached[tag][cacheKey];
    if (entry && !this.isExpired(entry)) {
      return Promise.resolve(entry.promise).catch(request);
    }
    return this.SetCache(tag, cacheKey, request());
  }

  protected SetCache(tag: string, cacheKey: string, request: Promise<any>) {
    if (!BaseApi.cached[tag]) {
      BaseApi.cached[tag] = {};
    }
    BaseApi.cached[tag][cacheKey] = { promise: request, timestamp: Date.now() };
    return request;
  }

  protected Clear = (tag: string) => {
    BaseApi.cached[tag] = {};
  };

  ClearCache = () => {
    BaseApi.cached = {};
  };
}
